(function () {
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var smallScreen = window.matchMedia("(max-width: 680px)").matches;
  var videos = document.querySelectorAll("[data-light-hero-video]");

  videos.forEach(function (video) {
    var allowMobileVideo = video.getAttribute("data-mobile-video") === "true";
    if (prefersReducedMotion || saveData || (smallScreen && !allowMobileVideo)) {
      video.removeAttribute("autoplay");
      video.pause();
      video.style.display = "none";
      return;
    }

    video.muted = true;
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === "function") {
      playAttempt.catch(function () {
        video.style.display = "none";
      });
    }
  });
})();

/* ─── Brand Story: scroll-triggered autoplay ─── */
(function () {
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  /* ── Native HTML5 video ── */
  document.querySelectorAll("[data-brand-story-video]").forEach(function (video) {
    video.muted = true;
    video.setAttribute("playsinline", "");

    var played = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !played) {
          played = true;
          var p = video.play();
          if (p && typeof p.catch === "function") p.catch(function () {});
          obs.unobserve(video);
        }
      });
    }, { rootMargin: "0px 0px -80px 0px", threshold: 0.25 });

    obs.observe(video);
  });

  /* ── YouTube iframe via Official IFrame API (確実な自動再生) ── */
  var ytTargets = document.querySelectorAll("[data-brand-story-yt][data-yt-id]");
  if (ytTargets.length > 0) {
    /* YouTube IFrame APIを動的読み込み */
    if (!window.YT) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    window.__brandStoryPlayers = window.__brandStoryPlayers || [];

    function initBrandStoryPlayer(wrapper) {
      var playerEl = wrapper.querySelector("[id^='bs-yt-player-']");
      if (!playerEl) return;
      var videoId = wrapper.getAttribute("data-yt-id");

      var player = new YT.Player(playerEl.id, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          mute: 1,
          playsinline: 1,
          controls: 1,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onReady: function (e) {
            var played = false;
            var obs = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && !played) {
                  played = true;
                  try {
                    e.target.mute();
                    e.target.seekTo(0);
                    e.target.playVideo();
                  } catch (err) {}
                  obs.unobserve(wrapper);
                }
              });
            }, { rootMargin: "0px 0px -80px 0px", threshold: 0.25 });
            obs.observe(wrapper);
          }
        }
      });
      window.__brandStoryPlayers.push(player);
    }

    window.onYouTubeIframeAPIReady = function () {
      ytTargets.forEach(initBrandStoryPlayer);
    };
    /* 既にAPIロード済みの場合（複数セクション読み込み時） */
    if (window.YT && window.YT.Player) {
      ytTargets.forEach(initBrandStoryPlayer);
    }
  }
})();

/* ─── モバイルメニュー（ハンバーガー開閉） ─── */
(function () {
  var toggle = document.querySelector("[data-mobile-menu-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  var overlay = document.querySelector("[data-mobile-menu-overlay]");
  if (!toggle || !menu) return;

  function openMenu() {
    menu.classList.add("is-open");
    if (overlay) overlay.classList.add("is-open");
    document.body.classList.add("menu-open");
    toggle.setAttribute("aria-expanded", "true");
  }
  function closeMenu() {
    menu.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    document.body.classList.remove("menu-open");
    toggle.setAttribute("aria-expanded", "false");
  }

  toggle.addEventListener("click", function () {
    if (menu.classList.contains("is-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });
  if (overlay) overlay.addEventListener("click", closeMenu);
  menu.addEventListener("click", function (e) {
    if (e.target.closest("a")) closeMenu();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMenu();
  });
})();

/* ─── UX batch2: バリエーション価格同期 / 二重送信防止 / honeypot ─── */
(function () {
  /* 商品ページ：バリエーション選択で価格表示を同期（option の data-price を反映） */
  var vsel = document.querySelector(".product-page select[name='id']");
  var priceEl = document.querySelector(".product-page .product-buy .price");
  if (vsel && priceEl) {
    vsel.addEventListener("change", function () {
      var opt = vsel.options[vsel.selectedIndex];
      var p = opt && opt.getAttribute("data-price");
      if (p) priceEl.textContent = p;
    });
  }

  /* お問い合わせフォーム：honeypot（ボット除外）＋ 二重送信防止 */
  document.querySelectorAll("form").forEach(function (form) {
    var ft = form.querySelector("input[name='form_type']");
    if (!ft || ft.value !== "contact") return;
    form.addEventListener("submit", function (e) {
      /* honeypot：非表示の囮欄に値 → ボットとみなし送信中止 */
      var hp = form.querySelector("input[name='contact[website_url]']");
      if (hp && hp.value.trim() !== "") { e.preventDefault(); return; }
      /* 送信中表示：送信処理が走った“後”に無効化（送信自体は止めない） */
      var btn = form.querySelector("button[type='submit'], input[type='submit']");
      if (btn && !btn.disabled) {
        setTimeout(function () {
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");
          if (btn.tagName === "BUTTON") { btn.dataset.origLabel = btn.textContent; btn.textContent = "送信中…"; }
        }, 0);
      }
    });
  });
})();
/* ─── UX batch5: モバイルメニューのフォーカストラップ＋復帰 ─── */
(function () {
  var toggle = document.querySelector("[data-mobile-menu-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  if (!toggle || !menu || !("MutationObserver" in window)) return;
  var lastFocus = null;
  function focusables() {
    return menu.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
  }
  var mo = new MutationObserver(function () {
    if (menu.classList.contains("is-open")) {
      lastFocus = document.activeElement;
      var f = focusables();
      if (f.length) setTimeout(function () { try { f[0].focus(); } catch (e) {} }, 30);
    } else if (lastFocus) {
      try { lastFocus.focus(); } catch (e) {}
      lastFocus = null;
    }
  });
  mo.observe(menu, { attributes: true, attributeFilter: ["class"] });
  menu.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();